import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Console } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { MomService } from 'src/app/service/mom.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { CancelMeetingPopupComponent } from '../cancel-meeting-popup/cancel-meeting-popup.component';
import { CopymeetingComponent } from '../copymeeting/copymeeting.component';
import { DeleteMeetingPopupComponent } from '../delete-meeting-popup/delete-meeting-popup.component';
import { NotHeldPopupComponent } from '../not-held-popup/not-held-popup.component';
import { PreviousMeetingsComponent } from '../previous-meetings/previous-meetings.component';
import { ProjectStatusDialogComponent } from '../right-side-opener/project-status-dialog.component';
import { ScheduleMeetingPopupComponent } from '../schedule-meeting-popup/schedule-meeting-popup.component';
import { TableDialogComponent } from '../table-dialog/table-dialog.component';
import { UpcomingMeetingComponent } from '../upcoming-meeting/upcoming-meeting.component';
import { ViewMomDialogComponent } from '../view-mom-dialog/view-mom-dialog.component';
import { TaskTitleDialogComponent } from '../left-side-opener/task-title-dialog.component';
import { TaskDataSource } from 'src/app/service/task.datasource';
import { DashboardService } from 'src/app/service/dashboard.service';

@Component({
  selector: 'app-confidential-dialog',
  templateUrl: './confidential-dialog.component.html',
  styleUrls: ['./confidential-dialog.component.css']
})
export class ConfidentialDialogComponent implements OnInit {
  //private readonly notifier!: NotifierService;
  confidentialIsCheck: boolean = false;
  isConfidentialValue: boolean = false;
  meetingid: any;
  passworddecrypt: any;
  meetingObj: any;
  meetingInfoData: any;
  viewMeetingInfo: any;
  meetingDateStr: any;
  agendaArray: any = [];
  byteData: any;
  pdfFlag: any;
  meetingStartFlag: any;
  isMeetingRunning: any;
  showMom: any;
  isMeetingCancelled:any;
  deleteMeeting:any;
  linkMeetings:any;
  scheduleMeeting:any;
  meetingJSON: any;
  copyMeeting:any;
  notHeldPop:any;
  viewMomPdfFlag:any;
  loadTask:any;
  taskID:any;
  taskJSON:any;
  meetingResheduleFlag:any;
  taskDataSource!: TaskDataSource;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  matDialogRef!: MatDialogRef<DeleteMeetingPopupComponent>;
  matDialogCancel!: MatDialogRef<CancelMeetingPopupComponent>;
  matDialogReference!: MatDialogRef<ScheduleMeetingPopupComponent>;
  matDialogCopyRef!: MatDialogRef<CopymeetingComponent>;
  matDialogNotHeld!: MatDialogRef<NotHeldPopupComponent>;
  matDialogTask!: MatDialogRef<TaskTitleDialogComponent>;
  viewMeetingTaskInfo: any;
  constructor(private dashboardService:DashboardService,private util:UtilityService,private readonly breakpointObserver: BreakpointObserver, private dialog: MatDialog, private spinner: NgxSpinnerService, private globals: Globals, public router: Router, private sideNav: SideNavServiceService, private webTranService: WebsocketTransferService, private meetingService: MeetingService, @Inject(MAT_DIALOG_DATA) data: any, public notifier: NotifierService, public dialogRef: MatDialogRef<ConfidentialDialogComponent>, private momService: MomService) {
    this.confidentialIsCheck = data['confidentialCheck'];
    this.viewMeetingInfo = data['viewMeetingInfo'];
    this.viewMeetingTaskInfo = data['viewMeetingTaskInfo']
    this.meetingObj = data['meetingObj'];
    this.meetingDateStr = data['meetingDateStr'];
    this.pdfFlag = data['pdfflag'];
    this.meetingStartFlag = data['meetingStartFlag'];
    this.isMeetingRunning = data['isMeetingRunning'];
    this.showMom = data['showMoM'];
    this.isMeetingCancelled=data['meetingCancelled'];
    this.deleteMeeting=data['deleteMeeting'];
    this.linkMeetings=data['linkMeetings'];
    this.copyMeeting=data['copyMeeting'];
    this.scheduleMeeting=data['scheduleMeeting'];
    this.notHeldPop=data['notHeldPop'];
    this.viewMomPdfFlag=data['viewMomPdfFlag'];
    this.meetingResheduleFlag=data['meetingResheduleFlag'];
    this.loadTask=data['loadTask'];
    this.taskID=data['taskID'];
    this.taskJSON=data['taskJSON'];
    if (data['flag'] == true) {
      this.meetingid = this.meetingObj.meetingId;
    }
    else {
      //this.meetingid=data['meetingId'];
      this.meetingid = this.meetingObj.meetingId;
    }
    this.dialogRef.afterOpened().subscribe((data: any) => {
      data = this.confidentialIsCheck;
      localStorage.setItem("dailogRefData", data);
      localStorage.setItem("decryptData", this.decryptPassword.value);
    });
    this.isConfidentialValue = data['isConfidentialCheck'];
    this.meetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.UPCOMING_MEETING_CONF,
      // "meetingStatus": [
      //   18,648
      // ],
      "startDelay": "60",
      "userId": this.globals.userId,
      "startDate": "",
      "endDate": "",
      "visitorTimeZone": this.globals.vTimeZone,
      "filterCol": ""
    }
    this.taskDataSource = new TaskDataSource(this.dashboardService);
  }

  password = new UntypedFormControl('', [Validators.required, Validators.minLength(8)]);
  confirmPassword = new UntypedFormControl('', [Validators.required, Validators.minLength(8)]);
  decryptPassword = new UntypedFormControl('', [Validators.required, Validators.minLength(8)]);
  show = false
  isShow = false;
  showLen=false;
  passwordHide = true;
  confirmPasswordHide = true;
  ngOnInit(): void {
    //
    //alert("attendeeObj::"+JSON.stringify(this.globals.userId));
  }
  viewMeeting(meetingObj: any) {
    this.passworddecrypt = localStorage.getItem("savedpasswords" + "_"+ this.meetingid);


    if (this.viewMeetingInfo == true || this.viewMeetingTaskInfo == true) {
      if (this.decryptPassword.value == "") {

        this.show = true
      } else {
        this.passworddecrypt = localStorage.getItem("savedpasswords" + "_"+ this.meetingid);
        if (this.decryptPassword.value != "") {
          
 
          if(this.viewMeetingTaskInfo == true){
            var jsonObj: any = {};
            jsonObj = {
              "meetingId": meetingObj.meetingId,
              "userId": this.globals.userId,
              "deletedFlag": 0,
              "rowStatus": "",
              "decryptKey": this.decryptPassword.value,
              "visitorTimeZone": this.globals.vTimeZone,
              "meetingUTCDate": this.meetingObj.meetingUTCDate,
              "meetingDate": this.meetingObj.meetingDate,
              "meetingStartTime": this.meetingObj.meetingStartTime,
              "meetingDateStr": this.meetingDateStr,
            }
            this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
              (meetingRes: any) => {
                this.meetingInfoData = meetingRes.body
                const d = this.dialog.open(TableDialogComponent, {
                  data: this.meetingInfoData,
                  panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100vw",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
                })
                const mediumDialogSubscription = this.isMedium.subscribe(size => {
                  if(size.matches){
                    d.updateSize('70vw','100vh');
                  }
                })
                const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
                  if (size.matches) {
                    d.updateSize('100vw', '100vh');
                  } else {
                    d.updateSize('50%', '100vh');
                  }
                });
                const smallSubscription = this.isSmall.subscribe(size => {
                  if(size.matches){
                    d.updateSize('100vw', '100vh');
                  }
                })
                d.afterClosed().subscribe(() => {
                  smallDialogSubscription.unsubscribe();
                  mediumDialogSubscription.unsubscribe();
                  smallSubscription.unsubscribe()
                });
                this.spinner.hide();
                this.isShow = false
                this.dialogRef.close();
              },
              err => {
                
                // this.spinner.hide()
                this.isShow = true

              }).add(() => {
                //Called when operation is complete (both success and error)
              });
          } else {
            var jsonObj: any = {};
            jsonObj = {
              "meetingId": meetingObj.meetingId,
              "userId": this.globals.userId,
              "deletedFlag": 0,
              "rowStatus": "",
              "decryptKey": this.decryptPassword.value,
              "visitorTimeZone": this.globals.vTimeZone,
              "meetingUTCDate": this.meetingObj.meetingUTCDate,
              "meetingDate": this.meetingObj.meetingDate,
              "meetingStartTime": this.meetingObj.meetingStartTime,
              "meetingDateStr": this.meetingDateStr,
            }
            this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
              (meetingRes: any) => {
                this.meetingInfoData = meetingRes.body
                if(this.meetingObj.meetingTitle == meetingRes.body.encryptTitleKey){
                  this.spinner.show();
                  const d = this.dialog.open(ProjectStatusDialogComponent, {
                    data: { meetingData: this.meetingInfoData, hide: false, hideUseTemplate: true },
                    panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
                    disableClose: false,
                    position: {
                      left: "50%"
                    },
                    maxWidth: "100%",
                    maxHeight: "100vh",
                    width: "50%",
                    height: "100vh"
                  })
                  this.dialogRef.close();
                  const mediumDialogSubscription = this.isMedium.subscribe(size => {
                    if (size.matches) {
                      d.updateSize('70vw', '100vh');
                    }
                  })
                  const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
                    if (size.matches) {
                      d.updateSize('100vw', '100vh');
                    } else {
                      d.updateSize('calc(100% - 50px)', '100vh');
                    }
                  });
                  const smallSubscription = this.isSmall.subscribe(size => {
                    if (size.matches) {
                      d.updateSize('100vw', '100vh');
                    }
                  })
                  d.afterClosed().subscribe(() => {
                    smallDialogSubscription.unsubscribe();
                    smallSubscription.unsubscribe();
                    mediumDialogSubscription.unsubscribe();
                  });
                  this.spinner.hide()
                }
              },
              err => {
                
                // this.spinner.hide()
                this.isShow = true

              }).add(() => {
                //Called when operation is complete (both success and error)
              });

          }

        }

        //}
      }
    }
    else {
      if (meetingObj.recurVisibleFlag != null && meetingObj.recurVisibleFlag == "Y") {
        this.createRecurChildMeeting(meetingObj);
      }
      if (this.pdfFlag == true) {
        this.agendaArray = [];
        this.meetingService.fetchMeetingInfo(meetingObj.meetingId).subscribe(
          (meetingRes: any) => {
            this.meetingInfoData = meetingRes.body;
            this.viewMomPdf(this.meetingInfoData);
            // var minuteJSON = {
            //   // "deletedFlag": 0,
            //   "meetingId": meetingObj.meetingId,
            //   "pkMomDetailId": meetingObj.pkMomDetailId,
            //   //"reviewType": "RA",
            //   //"orgCode": this.meetingInfoData.orgCode,
            //   "momStatus": environment_const.momApproveStatus,
            //   "userId": Number(localStorage.getItem("userId")),
            //   "reportedUsersId": this.globals.userId + "," + this.globals.repotingUsers,
            //   "fkMeetingEntityId": this.meetingInfoData.meetingId,
            // };
            // this.momService.viewMoM(minuteJSON).subscribe((response) => {
            //   let file = new Blob([response], { type: 'application/pdf' });
            //    this.byteData = file;
            //   var blobUrl = URL.createObjectURL(file);
            //    window.open(blobUrl);
            // })
          });
        this.close();
      }
      else {
        if (this.meetingStartFlag == "Y") {
          localStorage.setItem("decryptKey",this.decryptPassword.value)
          this.startMeeting(meetingObj);
        }
        else if (this.isMeetingRunning == true) {
          localStorage.setItem("decryptKey",this.decryptPassword.value)
          this.startMeeting(meetingObj);
        }
        else if(this.meetingResheduleFlag==true){
          this.reScheduleMeetingPopup(meetingObj);
        }
        else if(this.isMeetingCancelled==true){
          this.cancelMeetingPopup(meetingObj);
        }
        else if(this.deleteMeeting==true){
          this.deleteMeetingPopup(meetingObj);
        }
        else if(this.linkMeetings==true){
          this.openLinkMeetings(meetingObj);
        }
        else if(this.scheduleMeeting==true){
          this.openScheduleMeeting(meetingObj);
        }
        else if(this.copyMeeting==true){
          this.copyMeetings(meetingObj);
        }
        else if(this.notHeldPop==true){
          this.notHeldMeeting(meetingObj);
        }
        else if(this.viewMomPdfFlag==true){
          this.viewMomPdfflag(meetingObj);
        }
        else if(this.loadTask==true){
          localStorage.setItem("decryptKey",this.decryptPassword.value)
          this.loadTaskInfo(meetingObj);
        }
        else {
          localStorage.setItem("decryptKey",this.decryptPassword.value)
          this.redirectToMeeting(meetingObj);
        }
      }
    }
  }
  viewMomPdfflag(meetingInfoData:any){
    var jsonObj: any = {};
    jsonObj = {
      "meetingId": meetingInfoData.meetingId,
      "userId": this.globals.userId,
      "deletedFlag": 0,
      "rowStatus": "",
      "decryptKey": this.decryptPassword.value,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingUTCDate": this.meetingObj.meetingUTCDate,
      "meetingDate": this.meetingObj.meetingDate,
      "meetingStartTime": this.meetingObj.meetingStartTime,
      "meetingDateStr": this.meetingDateStr,
    }
    this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
      (meetingRes: any) => {

        if (this.decryptPassword.value == "") {
          this.show = true
        }
        else if(meetingInfoData.meetingTitle.trim() == meetingRes.body.encryptTitleKey.trim()) {
          this.passworddecrypt = localStorage.getItem("savedpasswords" + "_" + this.meetingid);
        }
        let viewMinutes = this.dialog.open(ViewMomDialogComponent,{
          data:{meetingInfo:meetingInfoData},
          panelClass: ['parent-dialog-container'],
          maxWidth : "100%",
          maxHeight : "100vh",
          minWidth : "80%",
          minHeight : "80vh",
        });
        this.dialogRef.close();
      },
      err => {
        this.spinner.hide();
        this.isShow = true

      });

  }
  notHeldMeeting(meetingInfo:any){
    this.matDialogNotHeld = this.dialog.open(NotHeldPopupComponent, {

      data:{
        meeting:meetingInfo
      },
      panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: true,
      position : {
        left : "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height : "100vh"

    });
    this.dialogRef.close();
    this.matDialogNotHeld.afterClosed().subscribe((data)=>{
      this.router.navigate(['dashboard']);
    });
  }
  copyMeetings(meeting:any){
    this.matDialogCopyRef = this.dialog.open(CopymeetingComponent, {
      data:{meeting},
      panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: true,
      position : {
        left : "0%"
      },
      maxWidth: "100vw",
      maxHeight: "100vh",
      width: "50%",
      height : "100vh"
    });
    this.dialogRef.close();
    this.matDialogCopyRef.afterClosed().subscribe((data)=>{
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);
    });
  }
  openScheduleMeeting(meetingObj:any){
    var reqJson ={
      "meetingId":meetingObj.meetingId,
      "userId": this.globals.userId,
      "visitorTimeZone":this.globals.vTimeZone
    }
    if(this.util.nvl(meetingObj.meetingFrequency)!="" && this.util.nvl(meetingObj.meetingFrequency)!="N" && this.util.nvl(meetingObj.recurVisibleFlag)=="" && this.util.nvl(meetingObj.recurTillDateAsMilliSec)!=""){
      this.createRecurParentMeeting(reqJson);
    }else{
      this.meetingService.scheduleMeeting(reqJson).subscribe(res => {
        // this.meetingDatasource.loadUpcomingMeetings(this.meetingJSON);
        this.router.navigate(['dashboard']);
        this.sideNav.alertSchedule("schedule");
      });
    }
    this.dialogRef.close();
  }
  createRecurParentMeeting(meetingJSON:any){
    // var reqJson ={
    //   "meetingId":meetingJSON.meetingId,
    //   "userId": this.globals.userId,
    //   "visitorTimeZone":this.globals.vTimeZone
    // }
    this.spinner.show();
    this.meetingService.createRecurParentMeeting(meetingJSON).subscribe(res => {
      this.meetingService.scheduleMeeting(meetingJSON).subscribe(res => {
        //this.meetingDatasource.loadUpcomingMeetings(this.meetingJSON);
        this.router.navigate(['dashboard']);
        this.sideNav.alertSchedule("schedule");
      });
    }).add(() => {
      this.spinner.hide();
    });
  }
  openLinkMeetings(meetingObj:any){
    const previousDialog =  this.dialog.open(PreviousMeetingsComponent,{
      data : {meetingResponse : meetingObj},
      panelClass: ['animate__animated','animate__slideInRight','rogowclass'],
      disableClose: true,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    this.dialogRef.close();
  }
  deleteMeetingPopup(meetingObj:any){
    this.matDialogRef = this.dialog.open(DeleteMeetingPopupComponent, {

      data: {
        meetingId:meetingObj.meetingId
      },
      panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
      disableClose: true,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: '100vh'
      // disableClose: true

    });
    this.dialogRef.close();
    this.matDialogRef.afterClosed().subscribe((data)=>{
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);

    });

  }
  cancelMeetingPopup(meetingObj:any){
    this.matDialogCancel = this.dialog.open(CancelMeetingPopupComponent, {

      data: {
        meetingId:meetingObj.meetingId
      },
      position: {
        left: "50%"
      },
      panelClass: ['animate__animated', 'animate__slideInRight'],
      disableClose: true,
      maxWidth: "100%",
      maxHeight: "100vh",
      height : "100vh",
      width : "50%"
      // disableClose: true

    });
    this.dialogRef.close();
    this.matDialogCancel.afterClosed().subscribe((data)=>{
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);

    });
  }
  reScheduleMeetingPopup(meetingObj:any){
    this.matDialogReference = this.dialog.open(ScheduleMeetingPopupComponent, {
      data: { meetingData: meetingObj },
      // disableClose: true
      panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
      disableClose: true,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    });
    this.dialogRef.close();
    this.matDialogReference.afterClosed().subscribe((data :any)=>
    {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);

    });
  }
  createRecurChildMeeting(obj: any) {
    var reqJson = {
      "recurDetailsId": obj.recurDetailsId,
      "meetingDateStr": obj.meetingDateStr,
      "meetingStartTime": obj.meetingStartTime,
      "orgCode": this.globals.orgCode,
      "userId": this.globals.userId,
      "visitorTimeZone": this.globals.vTimeZone
    }
    this.meetingService.createRecurChildMeeting(reqJson).subscribe(res => {
      if (res != null && res.body != null && res.body.meetingId != null) {
        if (res.body.meetingStartFlag == "Y") {
          this.startMeeting(res.body);
        } else {
          this.redirectToMeeting(res.body);
        }
      }
    });
  }

  viewMomPdf(meetingInfoData: any) {
    var jsonObj: any = {};
    jsonObj = {
      "meetingId": meetingInfoData.meetingId,
      "userId": this.globals.userId,
      "deletedFlag": 0,
      "rowStatus": "",
      "decryptKey": this.decryptPassword.value,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingUTCDate": this.meetingObj.meetingUTCDate,
      "meetingDate": this.meetingObj.meetingDate,
      "meetingStartTime": this.meetingObj.meetingStartTime,
      "meetingDateStr": this.meetingDateStr,
    }
    this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
      (meetingRes: any) => {
        if (this.decryptPassword.value == "") {
          this.show = true
        }
        else if(meetingInfoData.meetingTitle.trim() == meetingRes.body.encryptTitleKey.trim()) {
          this.passworddecrypt = localStorage.getItem("savedpasswords" + "_" + this.meetingid);
        }
        let viewMinutes = this.dialog.open(ViewMomDialogComponent, {
          data: { meetingInfo: meetingInfoData },
          panelClass: ['parent-dialog-container'],
          maxWidth: "100%",
          maxHeight: "100vh",
          minWidth: "80%",
          minHeight: "80vh",
        })
        this.dialogRef.close();
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            viewMinutes.updateSize('70vw', '100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            viewMinutes.updateSize('100vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            viewMinutes.updateSize('100vw', '100vh');
          }
          // else {
          //   this.matDialogRef.updateSize('50%', '100vh');
          // }
        });
        viewMinutes.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
        });


      },
      err => {
        this.spinner.hide();
        this.isShow = true

      });

  }
  handleKeyboardEvent(meetingObj:any,event: any) {
        if (event.keyCode === 13) {
      if (this.confidentialIsCheck != null) {
        if (this.confidentialIsCheck) {
          this.validation();
        }
        if (!this.confidentialIsCheck && !this.isConfidentialValue) {
          this.decryptValidation();
        }
      }
      else {
        this.viewMeeting(meetingObj);
      }
    }

  }
  validation() {
    if (this.password.value == "" || this.confirmPassword.value == "") {
      this.show = true
    }
    else if(this.password.value.length<8 || this.confirmPassword.value.length<8){
      this.showLen= true;
    }
    else if (this.password.value != this.confirmPassword.value) {
      this.isShow = true
    }
    else {
      this.show = false
      this.showLen=false
      this.isShow = false;
      if (this.confirmPassword.value != "") {
        localStorage.setItem("savedpasswords" + "_" + this.meetingid, this.confirmPassword.value);
        localStorage.setItem("decryptKey", this.confirmPassword.value);
        let confidentialObj = {
          "encryptTitleKey":this.meetingObj.meetingTitle,
          "isConfidential": "Y",
          "orgCode": this.globals.orgCode,
          "visitorTimeZone": this.globals.vTimeZone,
          "userId": this.globals.userId,
          "meetingUTCDate": this.meetingObj.meetingUTCDate,
          "meetingDate": this.meetingObj.meetingDate,
          "meetingStartTime": this.meetingObj.meetingStartTime,
          "meetingDateStr": this.meetingDateStr,
          "rescheduleFlag": this.meetingObj.rescheduleFlag,
          "location":this.meetingObj.location,
          "decryptKey":this.confirmPassword.value,
        }
        this.meetingService.updateConfidentialMeeting(this.meetingid, confidentialObj).subscribe(response => {
          // this.notifier.notify("success", "Confidential Key saved successfully");
        })
      }
      this.dialogRef.close({ data: 'saved', isConfidential :'Y'  });
    }
  }
  decryptValidation() {
    if (this.decryptPassword.value == "") {
      this.show = true
    }
    else {
      this.passworddecrypt = localStorage.getItem("decryptKey")
      if (this.decryptPassword.value != "") {
        if (this.passworddecrypt == this.decryptPassword.value) {

          let confidentialObj = {
            "isConfidential": "N",
            "orgCode": localStorage.getItem("orgCode"),
            "visitorTimeZone": this.globals.vTimeZone,
            "userId": this.globals.userId,
            "meetingUTCDate": this.meetingObj.meetingUTCDate,
            "meetingDate": this.meetingObj.meetingDate,
            "meetingStartTime": this.meetingObj.meetingStartTime,
            "meetingDateStr": this.meetingDateStr,
            "location":this.meetingObj.location,
            "decryptKey":localStorage.getItem("decryptKey"),
          }
          this.meetingService.updateConfidentialMeeting(this.meetingid, confidentialObj).subscribe(response => {
            // this.notifier.notify("success", "Confidential Key removed successfully");
          });
          this.isShow = false
          this.dialogRef.close({ data: 'decrypt',isConfidential: 'N' });

        }else{
          this.isShow = true

        }
      }
      else {
        this.isShow = true
      }

      // }
    }
  }
  cancelConfidential() {
    this.dialogRef.close({ confirmPassword: this.confirmPassword.value });
  }
  cancelDecrypt() {
    this.dialogRef.close({ decrypt: this.decryptPassword.value });
  }
  redirectToMeeting(meetingObj: any) {
    var jsonObj: any = {};
    jsonObj = {
      "meetingId": meetingObj.meetingId,
      "userId": this.globals.userId,
      "deletedFlag": 0,
      "rowStatus": "",
      "decryptKey": this.decryptPassword.value,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingUTCDate": this.meetingObj.meetingUTCDate,
      "meetingDate": this.meetingObj.meetingDate,
      "meetingStartTime": this.meetingObj.meetingStartTime,
      "meetingDateStr": this.meetingDateStr,
    }
    this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(

      (meetingRes: any) => {
        if (this.decryptPassword.value == "") {
          this.show = true
        }

        else {
          this.passworddecrypt = localStorage.getItem("savedpasswords" + "_" + this.meetingid);
          if (this.decryptPassword.value != "") {
            if (this.showMom == true) {
              this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingObj.meetingId, "decryptKey": this.decryptPassword.value, "isConfidential": "Y", meetingObj: this.meetingObj, "showMoM": this.showMom }) }, skipLocationChange: true, replaceUrl: false });
            }
            else {
              this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingObj.meetingId, "decryptKey": this.decryptPassword.value, "isConfidential": "Y", meetingObj: this.meetingObj }) }, skipLocationChange: true, replaceUrl: false });
            }
            this.isShow = false
            this.dialogRef.close();
          }
          else {
            this.isShow = true
          }
        }
      },
      err => {
        this.spinner.hide();
        this.isShow = true
      });
    // }
  }
  startMeeting(meetingObj: any) {
    var jsonObj = {
      "meetingId": meetingObj.meetingId,
      "userId": this.globals.userId,
      "deletedFlag": 0,
      "rowStatus": "",
      "decryptKey": this.decryptPassword.value,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingUTCDate": this.meetingObj.meetingUTCDate,
      "meetingDate": this.meetingObj.meetingDate,
      "meetingStartTime": this.meetingObj.meetingStartTime,
      "meetingDateStr": this.meetingDateStr,
    }
    this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
      (meetingRes: any) => {

        if (this.decryptPassword.value == "") {
          this.show = true
        }
        else {
          this.passworddecrypt = localStorage.getItem("savedpasswords" + "_"+ this.meetingid);
          if (this.decryptPassword.value != "") {
            //if (this.passworddecrypt == this.decryptPassword.value) {
            var jsonObj = {
              "meetingId": meetingObj.meetingId,
              "userId": this.globals.userId,
            }
            this.meetingService.startMeeting(jsonObj).subscribe((meetingRes: any) => {
              this.sideNav.openInstantMeeting(true);
              var reqJson = { "meetingId": meetingObj.meetingId, "userId": localStorage.getItem("userId"), "loggedStatus": "LOGIN" }
              this.webTranService.pushUserLoggedInStatus(meetingObj.meetingId, reqJson).subscribe((data) => {
              });
              //this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingObj.meetingId, "decryptKey": this.decryptPassword.value, "isConfidential": "Y","isMeetingRunning":true,meetingObj: this.meetingObj,"zoomMeetingId":meetingObj.zoomMeetingId,"zoomPassword":meetingObj.zoomPassword }) }, skipLocationChange: true, replaceUrl: false });
              this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingObj.meetingId,"decryptKey": this.decryptPassword.value, "isConfidential": "Y","isMeetingRunning":true,meetingObj: this.meetingObj, }) }, skipLocationChange: true, replaceUrl: false });
            },
              err => {
                //
              });
            this.isShow = false
            this.dialogRef.close();
          }
          else {
            this.isShow = true;
          }
          //}

        }
      },
      err => {
        this.spinner.hide();
        this.isShow = true

      }
    )
  }
  close() {
    this.dialogRef.close();
  }
  formCheck() {

    let password = document.getElementById("password")?.innerHTML;
    let confirmPassword = document.getElementById("confirmPassword")?.innerHTML;
    if (password == '' || confirmPassword == '') {
      // window.alert("alert called")
      this.show = true
    }
    else {
      this.show = false
    }
  }
  taskInfoData:any;
  loadTaskInfo(meetingObj: any){
    var jsonObj = {
      "meetingId": meetingObj.meetingId,
      "userId": this.globals.userId,
      "deletedFlag": 0,
      "rowStatus": "",
      "decryptKey": this.decryptPassword.value,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingUTCDate": this.meetingObj.meetingUTCDate,
      "meetingDate": this.meetingObj.meetingDate,
      "meetingStartTime": this.meetingObj.meetingStartTime,
      "meetingDateStr": this.meetingDateStr,
    }
    this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
      (res: any) => {
        if (this.decryptPassword.value == "") {
          this.show = true
        }
        else {
          this.passworddecrypt = localStorage.getItem("savedpasswords" + "_"+ this.meetingid);
          if (this.decryptPassword.value != "") {
            this.meetingService.fetchTaskInfo(this.taskID).subscribe(
              (meetingRes: any) => {
           
                this.taskInfoData = meetingRes.body;
                this.matDialogTask = this.dialog.open(TaskTitleDialogComponent,{
                  data : {taskData : this.taskInfoData, meetingData : this.meetingObj},
                  panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth: "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
                });
                this.isShow = false
                this.dialogRef.close();
              })
          }

          else{
            this.isShow = true;
          }
        }
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogRef.updateSize('100vw', '100vh');
          } else {
            this.matDialogRef.updateSize('50%', '100vh');
          }
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            this.matDialogRef.updateSize('70vw','100vh');
          }
        })
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            this.matDialogRef.updateSize('100vw', '100vh');
          }
        })
        this.matDialogRef.afterClosed().subscribe((data:any)=>{
          this.taskDataSource.loadTasks(this.taskJSON);
          mediumDialogSubscription.unsubscribe();
          smallDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
        });

        // d.afterClosed().subscribe(() => {
        // });
      },
      err=>{
        this.spinner.hide();
        this.isShow = true
      });
  }


}
